import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, SFL_LETTER_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const ScreeningLetterPage = lazy(() => import('@features/HealthAssessment/ScreeningLetter/pages/ScreeningLetterPage'));

export const SCREENING_LETTER_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningLetterPage />,
    displayTitle: () => 'Healthier SG Screening',
    pageType: PageType.PRIVATE,
    path: SFL_LETTER_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSgScreening,
  },
];
